import { SVG, SVGProps } from './svg'

export function IconToolXABCD(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <path
        fillRule="evenodd"
        d="M11 8a2 2 0 0 0 .42-.04l3.27 6.53a2 2 0 0 0-.46 2.43L7.1 23.33a2.02 2.02 0 0 0-.13-.08L10.99 8H11zM6.01 23l4.01-15.25a2 2 0 1 1 2.3-.24l3.26 6.53a2.01 2.01 0 0 1 1.56.32l4.06-3.48a2 2 0 1 1 2.46 1l.68 8.15a2 2 0 1 1-2.19 1.2l-4.9-3.67A2 2 0 0 1 16 18c-.4 0-.79-.12-1.1-.33l-7.13 6.4A2 2 0 1 1 6 23zm-.27 1.03a1 1 0 1 0 1.24.76 1 1 0 0 0-1.24-.75zm9.43-8.58a1 1 0 0 0 1.22 1.47 1 1 0 0 0 .6-.8 1 1 0 0 0-.93-1.12 1 1 0 0 0-.9.45zM12 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm5.8 9.12 4.05-3.48c.24.17.51.28.81.33l.68 8.14a2 2 0 0 0-.59.33l-4.9-3.68a2 2 0 0 0-.05-1.64zm5.77-4.3A1 1 0 0 0 23 9a1 1 0 0 0-.98 1.18 1 1 0 0 0 1.55.64zM24 23a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
      />
    </SVG>
  )
}
